import { toast } from "react-toastify";
import axiosConfig from "../axiosConfig.js";

class CommonService {
    getAllPatientsMedicines = async (token) => {
        try {
            const response = await axiosConfig.get(`Medicine/GetAllPatientsMedicines`);
            return response;
        } catch (error) {
            toast.error(error?.message);
        }
    };
    getDemographicsState = async (token) => {
        try {
            const response = await axiosConfig.get(`Demographics/state`);
            return response;
        } catch (error) {
            toast.error(error?.message);
        }
    };
    getCities = async (stateId, token) => {
        try {
            const response = await axiosConfig.get(`Demographics/state/${stateId}`);
            return response;
        } catch (error) {
            toast.error(error?.message);
        }
    };
    getStateZipCodes = async (cityId, token) => {
        try {
            const response = await axiosConfig.get(`Demographics/city/${cityId}`);
            return response;
        } catch (error) {
            toast.error(error?.message);
        }
    };

    updateDeviceTokenRepo = async (tokenFCM, token) => {
        try {
            const response = await axiosConfig.patch(`user/UpdateUserDeviceToken`, { DeviceToken: tokenFCM });
            if (response.status === 200) {
                console.log("Device token updated successfully.");
                return true;
            }
        } catch (error) {
            console.error("Error updating device token:", error.message);
            // Track event (mocked here)
            // trackEvent("API Error", error.message);
            return null;
        }
    };
}

const instance = new CommonService();

export default instance;
